module.exports = __webpack_public_path__ + "static/fa7-f6275162c010c7568be1317b5d093dd1.jpg";